
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class UtentiDelegatiConProprietaGrid extends Serenity.EntityGrid<UtentiDelegatiConProprietaRow, any> {
        protected getColumnsKey() { return UtentiDelegatiConProprietaColumns.columnsKey; }
        protected getDialogType() { return UtentiDelegatiConProprietaDialog; }
        protected getIdProperty() { return UtentiDelegatiConProprietaRow.idProperty; }
        protected getInsertPermission() { return UtentiDelegatiConProprietaRow.insertPermission; }
        protected getLocalTextPrefix() { return UtentiDelegatiConProprietaRow.localTextPrefix; }
        protected getService() { return UtentiDelegatiConProprietaService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "column-picker-button"), 1);

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "refresh-button"), 1);

            //
            return buttons;
        }
    }
}